export enum PlanColors {
	PRIMARY = 'var(--color-plan-primary)',
	PRIMARY900 = 'var(--color-plan-primary-900)',
	PRIMARY800 = 'var(--color-plan-primary-800)',
	PRIMARY700 = 'var(--color-plan-primary-700)',
	PRIMARY600 = 'var(--color-plan-primary-600)',
	PRIMARY500 = 'var(--color-plan-primary-500)',
	PRIMARY400 = 'var(--color-plan-primary-400)',
	PRIMARY300 = 'var(--color-plan-primary-300)',
	PRIMARY200 = 'var(--color-plan-primary-200)',
	PRIMARY100 = 'var(--color-plan-primary-100)',
}
